import { TableColumn } from "../table/TableColumn";

const EventTypeColumns: TableColumn[] = [
    {
        heading: "Type",
        accessor: "name",
        isNumeric: false,
        id: 0,
        sortByName: "trnName",
        sortDirection: "asc",
        active: true,
        translationKey: "type",
        isDefault: true,
    },
    {
        heading: "Alarm",
        accessor: "etAlarmLabel",
        isNumeric: false,
        id: 1,
        active: true,
        translationKey: "alarm",
        sortByName: "etAlarm",
        sortDirection: "asc",
        isDefault: true,
    },
    {
        heading: "Priority Level",
        accessor: "etPriorityLevelLabel",
        isNumeric: false,
        id: 2,
        active: true,
        translationKey: "priorityLevel",
        sortByName: "etPriorityLevel",
        sortDirection: "asc",
        isDefault: true,
    }
];

export default EventTypeColumns;
